<template>
    <div :class="['menu-modal', modalClass]">
        <div :class="['menu-modal__container animate__animated', animationClass]">
            <div class="menu-modal__wrapper">
                <slot name="content">
                    <h3>Title</h3>
                    <p>Description</p>
                </slot>

                <slot name="actions">
                    <button>Button</button>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuModal',
    props: ['modalClass'],
    data() {
        return {
            animationClass: null
        }
    },
    methods: {
        onWindowResize() {
            if (window.innerWidth <= 767) {
                this.animationClass = 'animate__slideInUp';
            } else if (window.innerWidth > 767 && this.modalClass == 'menu-modal--wider') {
                this.animationClass = 'animate__bounceInUp';
            } else {
                this.animationClass = 'animate__bounceInRight';
            }
        }
    },
    mounted() {
        window.addEventListener("resize", this.onWindowResize);
        this.onWindowResize();
    },
    unmounted() {
        window.removeEventListener("resize", this.onWindowResize);
    }
}
</script>
